import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { Certificate, CertificateListResponse, CertificateQueryParams, CreateCertificate, UpdateCertificate } from '@frontend/certificate/types';

export class CertificateClient extends APIClient {
    public static readonly endpoint = '/certificate-api/v1';

    public static async fetchCertificates(queryParams?: ApiQueryParams<CertificateQueryParams>): Promise<CertificateListResponse> {
        return await this.apiPaginated<CertificateListResponse, CertificateQueryParams>(`${this.endpoint}/certificates`, queryParams);
    }

    public static async resolveCertificates(certificateIds: string[]): Promise<CertificateListResponse> {
        const response = await this.post(`${this.endpoint}/certificates-resolve`, { ids: certificateIds });
        return await this.handleResponse<CertificateListResponse>(response);
    }

    public static async deleteCertificates(certificateIds: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/certificates-delete`, { ids: certificateIds });
        return await this.handleVoidResponse(response);
    }

    public static async postCertificate(accountId: string, certificate: CreateCertificate): Promise<Certificate> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/certificates`, certificate);
        return await this.handleResponse<Certificate>(response);
    }

    public static async fetchCertificate(accountId: string, certificateId: string): Promise<Certificate> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/certificates/${certificateId}`);
        return await this.handleResponse<Certificate>(response);
    }

    public static async patchCertificate(accountId: string, certificateId: string, certificate: UpdateCertificate): Promise<Certificate> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/certificates/${certificateId}`, certificate);
        return await this.handleResponse<Certificate>(response);
    }

    public static async deleteCertificate(accountId: string, certificateId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/certificates/${certificateId}`);
        return await this.handleVoidResponse(response);
    }

    public static async postIoTSeed(accountId: string, iotId: string, body: { account_id: string }): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/iots/${iotId}/seed`, body);
        return this.handleResponse(response);
    }
}
